import { Checkbox, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import Select from 'src/shared/components/Form/Select';
import { SELECT_ALL_VALUE, useSelectCheckbox } from './hook';
import { required } from 'redux-form-validators';
import { formatMultipleSelected } from '../../Factorial/utils';
import { useTranslation } from 'react-i18next';

type SelectCheckboxProps = {
  data: Array<{ label: string; value: string }>;
  name: string;
};

export const SelectCheckbox = ({ data, name }: SelectCheckboxProps) => {
  const { handleChange, values } = useSelectCheckbox(data, name);
  const { t } = useTranslation('settings');

  return (
    <Select
      multiple
      sx={{ width: '300px' }}
      label={t('integrations.select')}
      name={name}
      renderValue={formatMultipleSelected(data)}
      onChange={handleChange}
      fieldProps={{ validate: required() }}
    >
      <MenuItem value={SELECT_ALL_VALUE}>
        <ListItemIcon>
          <Checkbox checked={data?.length === values?.[name]?.length} />
        </ListItemIcon>
        <ListItemText primary={t('integrations.select all')} />
        <ListItemText primary={''} />
      </MenuItem>
      {data.map(({ label, value }) => {
        return (
          <MenuItem key={label} value={value}>
            <Checkbox key={values?.[name]?.includes(value)} checked={values?.[name]?.includes(value)} />
            <ListItemText primary={label} />
          </MenuItem>
        );
      })}
    </Select>
  );
};
